import { normalizeSupportedDeviceType, type SupportedDeviceType } from '@/lib/device-capabilities';

export type SetupImage = {
  src: string;
  alt: string;
};

export const BUDDY_ETHERNET_PORT_ICON_1: SetupImage = {
  src: '/setup/Wiley Buddy Ethernet Port Icon 1.png',
  alt: 'Ethernet port symbol shown on the bottom of the Wiley Buddy base',
};

export const BUDDY_ETHERNET_PORT_ICON_2: SetupImage = {
  src: '/setup/Wiley Buddy Ethernet Port Icon 2.png',
  alt: 'Alternate Ethernet port symbol commonly shown on a home internet router',
};

export const BUDDY_SETUP_IMAGES: SetupImage[] = [
  { src: '/setup/Wiley Buddy Step 1 - Wiley Setup Images.jpg', alt: 'Step 1: Connect the spiral handset cord' },
  { src: '/setup/Wiley Buddy Step 2 - Wiley Setup Images.jpg', alt: 'Step 2: Connect the ethernet cord to the phone' },
  { src: '/setup/Wiley Buddy Step 3 - Wiley Setup Images.jpg', alt: 'Step 3: Connect ethernet cord to your home internet router' },
  { src: '/setup/Wiley Buddy Step 4 - Wiley Setup Images.jpg', alt: 'Step 4: Connect the phone to power' },
];

export const MAGIC_BOX_SETUP_IMAGES: SetupImage[] = [
  { src: '/setup/Wiley Magic Box Step 1 - Wiley Setup Images.jpg', alt: 'Step 1: Plug the Magic Box into power' },
  { src: '/setup/Wiley Magic Box Step 2 - Wiley Setup Images.jpg', alt: 'Step 2: Connect the Magic Box (blue port) to your router' },
  { src: '/setup/Wiley Magic Box Step 3 - Wiley Setup Images.jpg', alt: 'Step 3: Connect your phone to the Magic Box (green port)' },
];

const SETUP_IMAGES_BY_DEVICE_TYPE: Record<SupportedDeviceType, SetupImage[]> = {
  ghp610w: BUDDY_SETUP_IMAGES,
  ghp611w: BUDDY_SETUP_IMAGES,
  ht801: MAGIC_BOX_SETUP_IMAGES,
};

const BUDDY_WIZARD_IMAGES: Array<SetupImage | undefined> = [
  BUDDY_SETUP_IMAGES[0],
  BUDDY_SETUP_IMAGES[1],
  BUDDY_SETUP_IMAGES[2],
  BUDDY_SETUP_IMAGES[3],
  undefined,
];

const MAGIC_BOX_WIZARD_IMAGES: Array<SetupImage | undefined> = [
  {
    src: MAGIC_BOX_SETUP_IMAGES[0].src,
    alt: 'Step 1: Plug the ethernet cable into the blue port on the Magic Box',
  },
  {
    src: MAGIC_BOX_SETUP_IMAGES[1].src,
    alt: 'Step 2: Connect the Magic Box ethernet cable to your internet router',
  },
  MAGIC_BOX_SETUP_IMAGES[2],
  undefined,
  undefined,
];

export function getSetupImagesForDeviceType(deviceType?: string | null): SetupImage[] {
  const normalizedType = normalizeSupportedDeviceType(deviceType);
  return normalizedType ? SETUP_IMAGES_BY_DEVICE_TYPE[normalizedType] : BUDDY_SETUP_IMAGES;
}

export function getConnectionWizardImage(deviceType?: string | null, stepIndex?: number): SetupImage | undefined {
  if (stepIndex === undefined || stepIndex < 0) {
    return undefined;
  }

  const normalizedType = normalizeSupportedDeviceType(deviceType);
  if (!normalizedType) {
    return BUDDY_WIZARD_IMAGES[stepIndex];
  }

  return normalizedType === 'ht801' ? MAGIC_BOX_WIZARD_IMAGES[stepIndex] : BUDDY_WIZARD_IMAGES[stepIndex];
}